import type { IconProps } from "../types";

export const Home = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M15 21v-9H9v9" />
    <path d="M3 10 12 2 21 10V21H3Z" />
  </svg>
);
